import { render, staticRenderFns } from "./Talk.vue?vue&type=template&id=26348e0b&scoped=true&"
import script from "./Talk.vue?vue&type=script&lang=ts&"
export * from "./Talk.vue?vue&type=script&lang=ts&"
import style0 from "./Talk.vue?vue&type=style&index=0&id=26348e0b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26348e0b",
  null
  
)

export default component.exports